import {Injectable} from '@angular/core';
import {AppService} from '../../app.service';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CatalogsService extends AppService {
    className: string = 'CatalogsService';
    /**
     * URL страницы
     */
    url: string = '/rubricator/front_rubricator';

    /**
     * Получение записи
     * @param data данные
     */
    public getItem(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/get_item', data, this._httpOptions);
    }

    /**
     * Сохранение целой записи
     * @param data данные
     */
    public save(data: any): Observable<any> {
        return this.http.post<any>(this.serverUrl + this.url + '/save', data, this._httpOptions);
    }
}
